import { account as bnAccount } from "./bn/account.js";
import { accounting as bnAccounting } from "./bn/accounting.js";
import { audit as bnAudit } from "./bn/audit.js";
import { auth as bnAuth } from "./bn/auth.js";
import { billing as bnBilling } from "./bn/billing.js";
import { catalog as bnCatalog } from "./bn/catalog.js";
import { common as bnCommon } from "./bn/common.js";
import { customers as bnCustomers } from "./bn/customers.js";
import { dashboard as bnDashboard } from "./bn/dashboard.js";
import { errors as bnErrors } from "./bn/errors.js";
import { help as bnHelp } from "./bn/help.js";
import { inventory as bnInventory } from "./bn/inventory.js";
import { locations as bnLocations } from "./bn/locations.js";
import { nav as bnNav } from "./bn/nav.js";
import { notifications as bnNotifications } from "./bn/notifications.js";
import { orders as bnOrders } from "./bn/orders.js";
import { payments as bnPayments } from "./bn/payments.js";
import { pos as bnPos } from "./bn/pos.js";
import { purchasing as bnPurchasing } from "./bn/purchasing.js";
import { reports as bnReports } from "./bn/reports.js";
import { security as bnSecurity } from "./bn/security.js";
import { sessions as bnSessions } from "./bn/sessions.js";
import { settings as bnSettings } from "./bn/settings.js";
import { shipping as bnShipping } from "./bn/shipping.js";
import { shop as bnShop } from "./bn/shop.js";
import { staff as bnStaff } from "./bn/staff.js";
import { storefront as bnStorefront } from "./bn/storefront.js";
import { superAdmin as bnSuperAdmin } from "./bn/super-admin.js";
import { support as bnSupport } from "./bn/support.js";
import { validation as bnValidation } from "./bn/validation.js";
import { web as bnWeb } from "./bn/web.js";
import { account } from "./en/account.js";
import { accounting } from "./en/accounting.js";
import { audit } from "./en/audit.js";
import { auth } from "./en/auth.js";
import { billing } from "./en/billing.js";
import { catalog } from "./en/catalog.js";
import { common } from "./en/common.js";
import { customers } from "./en/customers.js";
import { dashboard } from "./en/dashboard.js";
import { errors } from "./en/errors.js";
import { help } from "./en/help.js";
import { inventory } from "./en/inventory.js";
import { locations } from "./en/locations.js";
import { nav } from "./en/nav.js";
import { notifications } from "./en/notifications.js";
import { orders } from "./en/orders.js";
import { payments } from "./en/payments.js";
import { pos } from "./en/pos.js";
import { purchasing } from "./en/purchasing.js";
import { reports } from "./en/reports.js";
import { security } from "./en/security.js";
import { sessions } from "./en/sessions.js";
import { settings } from "./en/settings.js";
import { shipping } from "./en/shipping.js";
import { shop } from "./en/shop.js";
import { staff } from "./en/staff.js";
import { storefront } from "./en/storefront.js";
import { superAdmin } from "./en/super-admin.js";
import { support } from "./en/support.js";
import { validation } from "./en/validation.js";
import { web } from "./en/web.js";
/** Languages of the UI (CLAUDE.md §1): English is the default and the source; Bengali is selectable. */
export const SUPPORTED_LOCALES = ["en", "bn"];
/** One namespace per module or area (docs/specs/admin-shell.md). Add `en` and `bn` together. */
export const resources = {
    en: {
        common,
        nav,
        auth,
        errors,
        validation,
        audit,
        sessions,
        security,
        settings,
        locations,
        catalog,
        inventory,
        purchasing,
        customers,
        orders,
        payments,
        shipping,
        billing,
        pos,
        dashboard,
        accounting,
        reports,
        notifications,
        support,
        account,
        help,
        staff,
        superAdmin,
        storefront,
        shop,
        web,
    },
    bn: {
        common: bnCommon,
        nav: bnNav,
        auth: bnAuth,
        errors: bnErrors,
        validation: bnValidation,
        audit: bnAudit,
        sessions: bnSessions,
        security: bnSecurity,
        settings: bnSettings,
        locations: bnLocations,
        catalog: bnCatalog,
        inventory: bnInventory,
        purchasing: bnPurchasing,
        customers: bnCustomers,
        orders: bnOrders,
        payments: bnPayments,
        shipping: bnShipping,
        billing: bnBilling,
        pos: bnPos,
        dashboard: bnDashboard,
        accounting: bnAccounting,
        reports: bnReports,
        notifications: bnNotifications,
        support: bnSupport,
        account: bnAccount,
        help: bnHelp,
        staff: bnStaff,
        superAdmin: bnSuperAdmin,
        storefront: bnStorefront,
        shop: bnShop,
        web: bnWeb,
    },
};
/** Every namespace, `common` first (the default for keys without a `ns:` prefix). */
export const NAMESPACES = [
    "common",
    "nav",
    "auth",
    "errors",
    "validation",
    "audit",
    "sessions",
    "security",
    "settings",
    "locations",
    "catalog",
    "inventory",
    "purchasing",
    "customers",
    "orders",
    "payments",
    "shipping",
    "pos",
    "dashboard",
    "accounting",
    "reports",
    "notifications",
    "billing",
    "support",
    "account",
    "help",
    "staff",
    "superAdmin",
    "storefront",
    "shop",
    "web",
];
//# sourceMappingURL=resources.js.map